var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "main",
      {
        staticClass: "layout",
        class: _vm.myEventSignal.isMonthView == true ? "month-mode" : "",
        attrs: { id: "mainLayout" },
      },
      [
        _c(
          "section",
          {
            staticClass: "panel",
            class: _vm.myEventSignal.isMonthView == true ? "hidden" : "",
            attrs: { id: "dayView" },
          },
          [
            _c("div", { staticClass: "daybar" }, [
              _c("div", { staticClass: "day-left" }, [
                _c(
                  "button",
                  {
                    staticClass: "arrow",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.next(-1)
                      },
                    },
                  },
                  [_vm._v("‹")]
                ),
                _vm._v(" "),
                _c("div", [
                  _c("h2", [_vm._v(_vm._s(_vm.getdatename))]),
                  _c("small", [
                    _vm._v(
                      _vm._s(
                        _vm.moment(_vm.date).locale("nl").format("DD MMM YYYY")
                      ) +
                        "· doorlopend tot " +
                        _vm._s(
                          _vm
                            .moment(_vm.date)
                            .add(1, "day")
                            .locale("nl")
                            .format("dddd D MMM")
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "arrow",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.next(1)
                      },
                    },
                  },
                  [_vm._v("›")]
                ),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]),
            _vm._v(" "),
            _c("activitybar", { attrs: { date: _vm.date } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "aside",
          {
            staticClass: "panel sidebar",
            class: _vm.myEventSignal.isMonthView == true ? "hidden" : "",
            attrs: { id: "staffSidebar" },
          },
          [_c("sidebar", { attrs: { date: _vm.date } })],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "panel",
            class: _vm.myEventSignal.isMonthView == false ? "hidden" : "",
            attrs: { id: "monthView" },
          },
          [_c("monthview")],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "day-actions" }, [
      _c("div", { staticClass: "legend" }, [
        _c("span", [
          _c("i", { staticStyle: { background: "var(--blue)" } }),
          _vm._v("beschikbaar"),
        ]),
        _vm._v(" "),
        _c("span", [
          _c("i", { staticStyle: { background: "var(--green)" } }),
          _vm._v("contract"),
        ]),
        _vm._v(" "),
        _c("span", [
          _c("i", { staticStyle: { background: "var(--red)" } }),
          _vm._v("override"),
        ]),
        _vm._v(" "),
        _c("span", [
          _c("i", { staticStyle: { background: "var(--purple)" } }),
          _vm._v("combidienst"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }